export const toggleClass = (el: HTMLElement, className: string): void => {
  if (el.classList.contains(className)) {
    el.classList.remove(className)
  } else {
    el.classList.add(className)
  }
}
